export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const phone = '+48 503 368 174';
export const email = 'r.sakalouski@andersenlab.com';
